<div class="container-fluid p-2" style="padding-left: 0px; padding-right: 0px">
  <h1>Casino Results</h1>
  <div class="container-fluid p-0">
    <div class="mt-2">
      <div class="form-group col-sm-12 p-1">
        <input
          type="input"
          formControlName="search"
          placeholder="Search"
          class="form-control"
          id="fromDate"
        />
      </div>
      <form class="w-100" [formGroup]="casinoFilterForm" (ngSubmit)="search()">
        <div class="d-flex flex-wrap col-sm-12 col-12 p-0">
          <div class="form-group col-sm-6 col-md-3 col-6 p-1">
            <label for="fromDate">Date</label>
            <input
              type="date"
              formControlName="f_date"
              class="form-control"
              id="fromDate"
            />
          </div>
          <div class="form-group col-sm-6 col-md-3 col-6 p-1">
            <label for="typefilter">Type</label>
            <select class="form-control" formControlName="game_name">
              <option value="">--select type--</option>
              <option *ngFor="let game of games" [value]="game.value">
                {{ game.name }}
              </option>
            </select>
          </div>
          <div class="text-left col-sm-12 col-md-3 col-12 p-1">
            <label for="toDate">&nbsp;</label>
            <button class="btn btn-block btn-dark text-light w-100">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="w-100 overflow-auto mt-2">
      <table class="table table-sm table-hover table-bordered table-green">
        <tbody *ngIf="casinoFilteredData.length > 0; else nodata">
          <tr
            *ngFor="let data of casinoFilteredData"
            (click)="openCasinoDetails(data)"
          >
            <td>
              <b>Round ID</b> <br />
              <b>Winner</b>
            </td>
            <td>
              {{ data.mid.substring(3) }} <br />
              <ng-container *ngIf="data.gtype == 'teen20'">
                Player {{ data.win | playername }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'teen9'">
                {{ getFullName(data.win | teenpattitest) }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'teen8'">
                {{ data.sid.split("|")[0] }}
              </ng-container>
              <ng-container
                *ngIf="data.gtype == 'dt20' || data.gtype == 'dt202'"
              >
                <!-- Player {{ data.win | dragontiger }} -->
                {{
                  data.win == 1
                    ? "Dragon"
                    : data.win == 2
                    ? "Tiger"
                    : "Tie"
                }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'dtl20'">
                <!-- {{ data.win | dragontigerlion }} -->
                {{
                  data.win == 1
                    ? "Dragon"
                    : data.win == 21
                    ? "Tiger"
                    : data.win == 41
                    ? "Lion"
                    : "Tie"
                }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'ab20'"> Win </ng-container>
              <ng-container *ngIf="data.gtype == 'abj'">
                {{ data.win == 1 ? "Andar" : "Bahar" }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'aaa'">
                {{
                  data.win == 1
                    ? "Amar"
                    : data.win == 2
                    ? "Akbar"
                    : data.win == 3
                    ? "Anthony"
                    : "Tie"
                }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'card32'">
                Player {{ data.win | card32name }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'card32eu'">
                Player {{ data.win | card32name }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'poker20'">
                Player {{ data.win | poker20 }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'poker'">
                Player {{ data.win | poker20 }}
              </ng-container>
              <ng-container *ngIf="data.gtype == 'poker9'">
                Player {{ data.win | poker6 }}
              </ng-container>
              <ng-container
                *ngIf="data.gtype == 'baccarat' || data.gtype == 'baccarat2'"
              >
                {{ data.description }}
              </ng-container>
            </td>
          </tr>
        </tbody>
        <ng-template #nodata>
          <tbody>
            <tr>
              <td>no data found</td>
            </tr>
          </tbody>
        </ng-template>
      </table>
    </div>
  </div>
</div>
